<ion-footer class="footer">
  <ion-toolbar class="footer__content">
    <div class="grid-completo">
      <ion-row class="">
        <ion-col sizeXs="12">
          <div class="footer__link">
            <a class="footer__link-item" (click)="openModal()">
              {{ 'footer.privacity' | translate }}
            </a>
            <a class="footer__link-item" (click)="openCookiesPage()">
              {{ 'footer.cookies' | translate }}
            </a>
            <!-- OneTrust Cookies Settings button start -->
            <button id="ot-sdk-btn" class="ot-sdk-show-settings" (click)="oneTrustEvent()">
              Cookie Settings
            </button>
            <!-- OneTrust Cookies Settings button end -->
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-xs="12">
          <div class="">
            <span>{{
              'footer.copyrigth'
                | translate : { field: currentYear | translate }
            }}</span>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </ion-toolbar>
</ion-footer>
